// components imports
import { Grid } from '@mui/material'
import { CustomController } from '../../../common/CustomController'

const ConsultBillingForm = () => {
  return (
    <Grid item xs={12}>
      <CustomController
        fieldType="number"
        controllerName="billing.consultationFee"
        controllerLabel="Consultation Fee ($)"
        dollarAdornment
        sx={{ my: 0 }}
      />
    </Grid>
  )
}

export default ConsultBillingForm
